import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Provider } from 'react-redux';

import ConnectedSidebar from './sidebar_container';
import configureStore from 'bundles/apex/deals/show/store/configure';

export default function DealsSidebar({ deals, ...props }) {
  const [store, setStore] = useState();

  useEffect(() => {
    setStore(configureStore(props));
  }, []);

  if (!deals?.length) {
    return null;
  }

  return (
    <Provider store={store}>
      <ConnectedSidebar deals={deals} />
    </Provider>
  );
}

DealsSidebar.propTypes = {
  deals: PropTypes.array,
};
